import { InjectionToken } from '@angular/core';
import { SupportedTypeMap } from '@nibtravel/shared/util/models';

export const CONTENTFUL_TYPE = new InjectionToken<SupportedTypeMap>(
  'Contentful Type'
);

export const CONTENTFUL_PROPS = new InjectionToken('Contentful Props');
